module.exports = __webpack_public_path__ + "img/sv8on.a2b2b627.svg";